<template>
  <div style="padding: 0;" class="d-flex align-center justify-content-center">
    <loading-indicator v-if="!loaded" />
    <iframe
      :class="loaded ? null : 'hidden'"
      style="padding: 0; border: none;"
      @load="loaded = true"
      src="https://eu-west-2.quicksight.aws.amazon.com/sn/embed/share/accounts/764076797896/dashboards/4457ddb7-3358-4922-a7cd-8cc91a3e2089?directory_alias=acada">
    </iframe>
  </div>
</template>

<script>
import LoadingIndicator from "@/components/LoadingIndicator";

export default {
  name: "QuickSightEmbed",
  components: {LoadingIndicator},

  data(){
    return {
      loaded: false,
      console
    }
  }
}
</script>

<style scoped>
iframe{
  height: 100%;
  width: 100%;
}

.hidden{
  display: none;
}
</style>
